<template>
  <div class="sub_content col-12 pt-2">
    <div class="row pb-2">
      <div class="col"></div>
      <div class="col-2">
        <b-form-input list="input-list" size="sm" placeholder="검색할 단어를 입력 해주세요."></b-form-input>
        <b-form-datalist id="input-list" :options="options"></b-form-datalist>
      </div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-1 text-right">
        <router-link tag="button" to="/car/write" class="btn btn-success btn-xs rounded-0">
          <i class="fas fa-plus"></i> 추가
        </router-link>
      </div>
    </div>
    <common-data-table
      hover
      class=""
      :totalPage="totalPage"
      :curPage="curPage"
      :url="'car'"
    >
      <template slot="header">
        <b-thead>
          <b-tr>
            <b-th>차량번호</b-th>
            <b-th>차량명</b-th>
            <b-th>차대번호</b-th>
            <b-th>회사</b-th>
            <b-th>운전자</b-th>
            <b-th>단말기ID</b-th>
            <b-th>등록일</b-th>
            <b-th>기능</b-th>
          </b-tr>
        </b-thead>
      </template>
      <template slot="body">
        <b-tbody>
          <b-tr v-for="(item, index) in items" :key="index">
            <b-td>{{ item.num }}</b-td>
            <b-td>{{ item.cname | carNameDisplay(item.brand) }}</b-td>
            <b-td>{{ item.vin }}</b-td>
            <b-td>{{ (item.csname) ? '('+item.csname+') ' : '' }} {{ item.cssname }}</b-td>
            <b-td>{{ item.uname || '' }}</b-td>
            <b-td>{{ item.termid || '' }}</b-td>
            <b-td>{{ item.indate }}</b-td>
            <b-td>
              <router-link tag="button" :to="{ name: 'CarView', params:{seq:item.seq}, query: $route.query}"
                           class="btn btn-xs btn-info mr-1 rounded-0">
                수정
              </router-link>
              <button type="button" v-on:click="delClick(item.seq)" class="btn btn-xs btn-danger rounded-0">
                삭제
              </button>
            </b-td>
          </b-tr>
        </b-tbody>
      </template>
    </common-data-table>
  </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import ax from '@/api/car'
import '@/filter/common'

export default {
  name: 'CarList',
  components: {
    commonDataTable
  },
  data () {
    return {
      options: ['옵션1', '옵션2'],
      curPage: parseInt(this.$route.query.page) || 1,
      totalPage: 1,
      items: []
    }
  },
  watch: {
    '$route.query': function () {
      this.curPage = parseInt(this.$route.query.page) || 1
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      ax.list(this.curPage, (data) => {
        if (data) {
          this.items = data.items
          this.totalPage = data.totalPage
        }
      })
    },
    delClick (seq) {
      ax.del(seq, (response) => {
        if (response) {
          this.init()
        } else {
          this.$notify({
            group: 'alert',
            type: 'warn',
            title: '경고',
            text: '삭제에 실패 하였습니다.'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
